"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var formLayout_1 = require("../../consts/formLayout");
var ReferenceIdentifierUtility_1 = require("../../../utils/ReferenceIdentifierUtility");
var axios_1 = __importDefault(require("axios"));
var ApiUtility_1 = require("../../../utils/ApiUtility");
var lodash_1 = require("lodash");
var form_item_1 = require("../form-item");
exports.translationMessages = react_intl_1.defineMessages({
    referenceIdentifiers_labels_addButton: {
        id: "referenceIdentifiers_labels_addButton",
        defaultMessage: "Add reference identifier",
    },
    referenceIdentifiers_labels_referenceIdentifier: {
        id: "referenceIdentifiers_labels_referenceIdentifier",
        defaultMessage: "Object identifier",
    },
    referenceIdentifiers_labels_referenceIdentifier_title: {
        id: "referenceIdentifiers_labels_referenceIdentifier_title",
        defaultMessage: "An identifier for an object on which the invoice is based, given by the seller. It may be a subscription number, telephone number, meter point, vehicle, person etc., as applicable.",
    },
    referenceIdentifiers_labels_AKG: {
        id: "referenceIdentifiers_labels_AKG",
        defaultMessage: "Vehicle identification number" // "Bílnúmer",
    },
    referenceIdentifiers_labels_ARR: {
        id: "referenceIdentifiers_labels_ARR",
        defaultMessage: "Kennitala" // "Kennitala",
    },
    referenceIdentifiers_labels_LOC: {
        id: "referenceIdentifiers_labels_LOC",
        defaultMessage: "Real estate number" // "Fasteignanúmer",
    },
});
var ReferenceIdentifiers = function (props) {
    var _a = react_1.useState([]), referenceIdentifierValue = _a[0], setReferenceIdentifierValue = _a[1];
    var _b = react_1.useState(false), loadingReferenceIdentifierValues = _b[0], setLoadingReferenceIdentifierValues = _b[1]; // TODO: change this to boolean[] for handling the list
    var referenceIdentifiersHelp = props.referenceIdentifiersHelpText ? props.referenceIdentifiersHelpText : props.intl.formatMessage(exports.translationMessages.referenceIdentifiers_labels_referenceIdentifier_title);
    var referenceIdentifiersLabel = props.referenceIdentifiersLabelText ? props.referenceIdentifiersLabelText : props.intl.formatMessage(exports.translationMessages.referenceIdentifiers_labels_referenceIdentifier);
    var referenceIdentifierOptions = ReferenceIdentifierUtility_1.getReferenceIdentifierOptions(props.receiverRequirements);
    var referenceIdentifiersHelpTextNode = react_1.default.createElement("div", null,
        react_1.default.createElement("p", null, referenceIdentifiersHelp),
        react_1.default.createElement("ul", null, referenceIdentifierOptions.map(function (x) {
            if (x.properties.hasOwnProperty("handling") && x.properties.handling) {
                var handling = JSON.parse(x.properties.handling);
                if (handling.hasOwnProperty("helpText") && handling.helpText.length > 0) {
                    return react_1.default.createElement("li", null, handling.helpText);
                }
            }
        })));
    var referenceIdentifierLabelNode = (react_1.default.createElement(antd_1.Tooltip, { title: referenceIdentifiersHelpTextNode, placement: "right" },
        react_1.default.createElement("span", null,
            referenceIdentifiersLabel,
            "\u00A0",
            react_1.default.createElement(icons_1.QuestionCircleOutlined, null))));
    var getReferenceIdentifier = function (receiverRequirements) {
        var options = ReferenceIdentifierUtility_1.getReferenceIdentifierOptions(receiverRequirements);
        if (options.length > 0) {
            return options.map(function (referenceIdentifierOption) {
                return react_1.default.createElement(antd_1.Select.Option, { key: referenceIdentifierOption.key, value: referenceIdentifierOption.key }, referenceIdentifierOption.properties.label);
            });
        }
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(antd_1.Select.Option, { value: "AKG" }, props.intl.formatMessage(exports.translationMessages.referenceIdentifiers_labels_AKG)),
            react_1.default.createElement(antd_1.Select.Option, { value: "ARR" }, props.intl.formatMessage(exports.translationMessages.referenceIdentifiers_labels_ARR)),
            react_1.default.createElement(antd_1.Select.Option, { value: "LOC" }, props.intl.formatMessage(exports.translationMessages.referenceIdentifiers_labels_LOC)));
    };
    var handleReferenceIdentifierValueSearch = lodash_1.debounce(function (searchValue, fieldDefinitionWithOriginalKey, receiverRequirements, rapiBaseUrl) {
        if (fieldDefinitionWithOriginalKey.properties.href) {
            // /api/v1/requirements/0196:5504030000/DepartmentLocation/values?textFilter=%7BtextFilter%7D&offset=%7Boffset%7D&limit=%7Blimit%7D
            var searchUrl = rapiBaseUrl + fieldDefinitionWithOriginalKey.properties.href.replace("%7BtextFilter%7D", encodeURIComponent(searchValue)).replace("%7Boffset%7D", "0").replace("%7Blimit%7D", "15");
            setLoadingReferenceIdentifierValues(true);
            axios_1.default.get(searchUrl, { cancelToken: ApiUtility_1.getCancelToken("referenceIdentifierValueSearch") })
                .then(function (response) {
                setLoadingReferenceIdentifierValues(false);
                var updatedFieldDefinitions = receiverRequirements.fieldDefinitions.slice();
                var index = updatedFieldDefinitions.findIndex(function (x) { return x.key === fieldDefinitionWithOriginalKey.originalKey; });
                var updatedReferenceIdentifier = __assign({}, updatedFieldDefinitions[index], { properties: {
                        label: updatedFieldDefinitions[index].properties.label,
                        href: updatedFieldDefinitions[index].properties.href,
                        cardinality: updatedFieldDefinitions[index].properties.cardinality,
                        values: response.data.value
                    } });
                updatedFieldDefinitions.splice(index, 1, updatedReferenceIdentifier);
                var newReceiverRequirements = __assign({}, receiverRequirements, { fieldDefinitions: updatedFieldDefinitions });
                props.updateReceiverRequirementsProp(newReceiverRequirements);
            })
                .catch(function (error) {
                setLoadingReferenceIdentifierValues(false);
            });
        }
    }, 500);
    var handleReferenceIdentifierValueValidation = lodash_1.debounce(function (isoNumber, fieldName, value, rapiBaseUrl, namePath, setReferenceIdentifierValidateStatus) {
        if (value.length === 0) {
            setReferenceIdentifierValidateStatus("");
            props.formInstance.resetFields([namePath]);
        }
        else {
            var searchUrl = rapiBaseUrl + ("/api/v1/requirements/" + isoNumber + "/" + fieldName + "/values/validate?value=" + encodeURIComponent(value));
            setReferenceIdentifierValidateStatus("validating");
            axios_1.default.get(searchUrl, { cancelToken: ApiUtility_1.getCancelToken("referenceIdentifierValueValidation") })
                .then(function (response) {
                response.data ? setReferenceIdentifierValidateStatus("success") : setReferenceIdentifierValidateStatus("error");
            })
                .catch(function (error) {
                setReferenceIdentifierValidateStatus("error");
            });
        }
    }, 500);
    var getReferenceIdentifierValueFormItemInput = function (value, receiverRequirements, rapiBaseUrl, legalIdentifier, field, referenceIdentifierValidateStatus, setReferenceIdentifierValidateStatus) {
        var fieldProps = __assign({}, field, { name: [field.name, "value"], 
            // fieldKey: [field.fieldKey, "value"],
            rules: [
                {
                    required: !!(value && value.key),
                    message: props.intl.formatMessage(form_item_1.translationMessages.formItem_required_errorMessage)
                }
            ] });
        if (value && value.key) {
            var options = ReferenceIdentifierUtility_1.getReferenceIdentifierOptions(receiverRequirements);
            var fieldDefinition_1 = options.find(function (el) { return el.key.endsWith(value.key); });
            if (fieldDefinition_1) {
                var fieldHandling = null;
                if (fieldDefinition_1.properties.hasOwnProperty("handling") && fieldDefinition_1.properties.handling) {
                    fieldHandling = JSON.parse(fieldDefinition_1.properties.handling);
                }
                if (fieldHandling && fieldHandling.shouldBeValidated) {
                    fieldProps = __assign({}, fieldProps, { validateStatus: referenceIdentifierValidateStatus, hasFeedback: true });
                    return (react_1.default.createElement(antd_1.Form.Item, __assign({}, fieldProps),
                        react_1.default.createElement(antd_1.Input, { onBlur: function (event) { return handleReferenceIdentifierValueValidation(legalIdentifier, fieldDefinition_1.name, event.currentTarget.value, rapiBaseUrl, ["invoice", "referenceIdentifiers", field.name, "value"], setReferenceIdentifierValidateStatus); } })));
                }
                if (fieldDefinition_1.properties.hasOwnProperty("values") && fieldDefinition_1.properties.values /*&& fieldDefinition.properties.values.length > 0*/) {
                    var selectProps = fieldDefinition_1.properties.hasOwnProperty("href")
                        ? {
                            showSearch: true,
                            filterOption: false,
                            onSearch: function (searchValue) {
                                handleReferenceIdentifierValueSearch(searchValue, fieldDefinition_1, receiverRequirements, rapiBaseUrl);
                            },
                            loading: loadingReferenceIdentifierValues,
                        }
                        : {};
                    return (react_1.default.createElement(antd_1.Form.Item, __assign({}, fieldProps),
                        react_1.default.createElement(antd_1.Select, __assign({ dropdownMatchSelectWidth: false }, selectProps), fieldDefinition_1.properties.values.map(function (op) {
                            return react_1.default.createElement(antd_1.Select.Option, { key: op.key, value: op.key }, op.name);
                        }))));
                }
                else {
                    return (react_1.default.createElement(antd_1.Form.Item, __assign({}, fieldProps),
                        react_1.default.createElement(antd_1.Input, null)));
                }
            }
            else {
                return (react_1.default.createElement(antd_1.Form.Item, __assign({}, fieldProps),
                    react_1.default.createElement(antd_1.Input, null)));
            }
        }
        return (react_1.default.createElement(antd_1.Form.Item, __assign({}, fieldProps),
            react_1.default.createElement(antd_1.Input, { disabled: true })));
    };
    var referenceIdentifiersDefinitions = ReferenceIdentifierUtility_1.getReferenceIdentifierFieldDefinitions(props.receiverRequirements);
    var getSingleReferenceIdentifierInput = function () {
        var fieldHandling = null;
        var fieldDefinition = referenceIdentifiersDefinitions[0];
        var singleReferenceIdentifierLabel = fieldDefinition.properties.label;
        var singleReferenceIdentifiersHelp;
        if (fieldDefinition.properties.hasOwnProperty("handling") && fieldDefinition.properties.handling) {
            fieldHandling = JSON.parse(fieldDefinition.properties.handling);
            singleReferenceIdentifiersHelp = fieldHandling.hasOwnProperty("helpText") ? fieldHandling.helpText : undefined;
        }
        var singleReferenceIdentifierLabelNode = singleReferenceIdentifiersHelp
            ? (react_1.default.createElement(antd_1.Tooltip, { title: singleReferenceIdentifiersHelp, placement: "right" },
                react_1.default.createElement("span", null,
                    singleReferenceIdentifierLabel,
                    "\u00A0",
                    react_1.default.createElement(icons_1.QuestionCircleOutlined, null))))
            : singleReferenceIdentifierLabel;
        if (fieldHandling && fieldHandling.shouldBeValidated) {
            return (react_1.default.createElement(antd_1.Form.Item, { name: ["invoice", "singleReferenceIdentifier", "value"], label: singleReferenceIdentifierLabelNode, validateStatus: props.referenceIdentifierValidateStatus, hasFeedback: true },
                react_1.default.createElement(antd_1.Input, { onBlur: function (event) { return handleReferenceIdentifierValueValidation(props.legalIdentifier, fieldDefinition.name, event.currentTarget.value, props.rapiBaseUrl, ["invoice", "singleReferenceIdentifier", "value"], props.setReferenceIdentifierValidateStatus); } })));
        }
        if (fieldDefinition.properties.hasOwnProperty("values") && fieldDefinition.properties.values) {
            var selectProps = fieldDefinition.properties.hasOwnProperty("href")
                ? {
                    showSearch: true,
                    filterOption: false,
                    onSearch: function (searchValue) {
                        handleReferenceIdentifierValueSearch(searchValue, __assign({}, fieldDefinition, { originalKey: fieldDefinition.key }), props.receiverRequirements, props.rapiBaseUrl);
                    },
                    loading: loadingReferenceIdentifierValues,
                }
                : {};
            return (react_1.default.createElement(antd_1.Form.Item, { name: ["invoice", "singleReferenceIdentifier", "value"], label: singleReferenceIdentifierLabel },
                react_1.default.createElement(antd_1.Select, __assign({ dropdownMatchSelectWidth: false }, selectProps), fieldDefinition.properties.values.map(function (op) {
                    return react_1.default.createElement(antd_1.Select.Option, { key: op.key, value: op.key }, op.name);
                }))));
        }
        else {
            return (react_1.default.createElement(antd_1.Form.Item, { name: ["invoice", "singleReferenceIdentifier", "value"], label: singleReferenceIdentifierLabel },
                react_1.default.createElement(antd_1.Input, null)));
        }
    };
    if (referenceIdentifiersDefinitions.length === 0) {
        return null;
    }
    else if (referenceIdentifiersDefinitions.length === 1) {
        props.formInstance.setFieldsValue({
            invoice: {
                singleReferenceIdentifier: {
                    code: referenceIdentifiersDefinitions[0].key.replace("referenceIdentifier.", "")
                }
            }
        });
        return (getSingleReferenceIdentifierInput());
    }
    else {
        return (react_1.default.createElement(antd_1.Form.List, { name: ["invoice", "referenceIdentifiers"] }, function (fields, _a) {
            var add = _a.add, remove = _a.remove;
            return (fields.map(function (field, index) {
                return (react_1.default.createElement(antd_1.Form.Item, __assign({ key: "referenceIdentifier-" + index }, (index === 0 ? formLayout_1.formItemLayout : formLayout_1.formItemLayoutWithOutLabel), { label: index === 0 ? referenceIdentifierLabelNode : "" }),
                    react_1.default.createElement(antd_1.Row, { gutter: [16, 0] },
                        react_1.default.createElement(antd_1.Col, { span: 12 },
                            react_1.default.createElement(antd_1.Form.Item, __assign({}, field, { name: [field.name, "code"], 
                                // fieldKey={[field.fieldKey, "code"]}
                                rules: [{ required: false }] }),
                                react_1.default.createElement(antd_1.Select, { labelInValue: true, allowClear: true, style: { width: "100%" }, dropdownMatchSelectWidth: false, onChange: function (a) {
                                        var newState = referenceIdentifierValue.slice();
                                        newState.splice(index, 1, a);
                                        setReferenceIdentifierValue(newState);
                                        props.setReferenceIdentifierValidateStatus("");
                                        props.formInstance.resetFields([["invoice", "referenceIdentifiers", index, "value"]]);
                                    } }, getReferenceIdentifier(props.receiverRequirements)))),
                        react_1.default.createElement(antd_1.Col, { span: 12 }, getReferenceIdentifierValueFormItemInput(referenceIdentifierValue[index], props.receiverRequirements, props.rapiBaseUrl, props.legalIdentifier, field, props.referenceIdentifierValidateStatus, props.setReferenceIdentifierValidateStatus)))));
            }));
        }));
    }
};
exports.default = react_intl_1.injectIntl(ReferenceIdentifiers);
